"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var dataSources;
        (function (dataSources) {
            var settings;
            (function (settings) {
                class InitArgs {
                    constructor() {
                        this.googleAccessTokenUrl = appn.emptyString;
                        this.initPicker = false;
                    }
                }
                let _initArgs;
                function init(args) {
                    _initArgs = args;
                    addEvents();
                    appn.folderFilter.initLinkedFolders();
                    if (_initArgs.initPicker) {
                        setTimeout(() => {
                            gapi.client.load('drive', 'v2');
                            gapi.load('picker', () => { });
                        }, 1000);
                    }
                    showHideFormData($('#RESTConnector_FormatType').val());
                    showHideFormDataPreStep($('#RESTConnector_PreStep_Format').val());
                    addTrashMessage();
                    initInlineSelects();
                    const connectionsSelect = $('select[id$="_ConnectionId"]');
                    if (appn.utils.hasValue(connectionsSelect))
                        showHideSiteNameOrCamlFilterOnSelect(connectionsSelect);
                    showHideSiteNameOrCamlFilter();
                    const xeroConnector = $('.box-connector-Xero');
                    if (appn.utils.hasValue(xeroConnector))
                        xeroUpdateEndpointSelect(xeroConnector);
                }
                settings.init = init;
                function initInlineSelects() {
                    appn.select.init({ selector: '.box-connector-Rest #RESTConnector_HttpAction,.box-connector-Rest #RESTConnector_FormatType,.box-connector-Rest #RESTConnector_PreStep_Verb,.box-connector-Rest #RESTConnector_PreStep_Format', omitWidth: true });
                }
                function addEvents() {
                    $('.connectorOption:not(.connection-required)').on('click', function () {
                        if ($(this).data('upgrade-required')) {
                            $('#upgradeReqd').modal('show');
                            return;
                        }
                        const form = $('form#appnForm');
                        form.append('<input type="hidden" name="submitType" value="' + $(this).attr('id') + '" />');
                        form.submit();
                    });
                    $('#addConnector').click(function () {
                        $('#connectorsDialog').modal('show');
                    });
                    $('.btnTryAddConnector').off().on('click', function (event) {
                        event.preventDefault();
                        $('#addConnector').click();
                    });
                    $('.btn-connector-run-now').off().on('click', function (event) {
                        event.preventDefault();
                        const link = $(this).attr('href');
                        appn.location.navTo(link);
                    });
                    $(document).on('click', '.addRestResponseMappingItem', function (event) {
                        event.preventDefault();
                        addRestResponseMappingItem();
                    });
                    $(document).on('click', '.deleteRestResponseMappingItem', function (event) {
                        event.preventDefault();
                        deleteRestResponseMapping($(this));
                    });
                    $(document).on('click', '.addRestHeaderItem', function (event) {
                        event.preventDefault();
                        addRestHeaderItem(appn.emptyString);
                    });
                    $(document).on('click', '.deleteRestHeaderItem', function (event) {
                        event.preventDefault();
                        deleteRestHeaderItem($(this), appn.emptyString);
                    });
                    $(document).on('click', '.addRestFormDataItem', function (event) {
                        event.preventDefault();
                        addRestFormDataItem(appn.emptyString);
                    });
                    $(document).on('click', '.deleteRestFormDataItem', function (event) {
                        event.preventDefault();
                        deleteRestFormDataItem($(this), appn.emptyString);
                    });
                    $(document).on('click', '.addRestHeaderItemPreStep', function (event) {
                        event.preventDefault();
                        addRestHeaderItem('PreStep');
                    });
                    $(document).on('click', '.deleteRestHeaderItemPreStep', function (event) {
                        event.preventDefault();
                        deleteRestHeaderItem($(this), 'PreStep');
                    });
                    $(document).on('click', '.addRestFormDataItemPreStep', function (event) {
                        event.preventDefault();
                        addRestFormDataItem('PreStep');
                    });
                    $(document).on('click', '.deleteRestFormDataItemPreStep', function (event) {
                        event.preventDefault();
                        deleteRestFormDataItem($(this), 'PreStep');
                    });
                    $(document).on('click', '.btnRestModifyHeaders', function (event) {
                        event.preventDefault();
                        $('.form-control-dsrest-headers').showElement();
                        $('.btnRestModifyHeaders').hideElement();
                    });
                    $(document).on('click', '.btnRestModifyBody', function (event) {
                        event.preventDefault();
                        showHideBody($('#RESTConnector_FormatType').val(), true);
                    });
                    $(document).on('click', '.btnRestModifyHeadersPreStep', function (event) {
                        event.preventDefault();
                        $('.form-control-dsrest-headers-prestep').showElement();
                        $('.btnRestModifyHeadersPreStep').hideElement();
                    });
                    $(document).on('click', '.btnRestModifyBodyPreStep', function (event) {
                        event.preventDefault();
                        showHideBodyPreStep($('#RESTConnector_PreStep_Format').val(), true);
                    });
                    $('#RESTConnector_FormatType').on('change', function () {
                        showHideBody($(this).val());
                        showHideFormData($(this).val());
                    });
                    $('#RESTConnector_PreStep_Format').on('change', function () {
                        showHideBodyPreStep($(this).val());
                        showHideFormDataPreStep($(this).val());
                    });
                    $(document).on('click', '.buildIcon', function () {
                        const icon = $(this);
                        let formulaInput = icon.closest('.input-group').find('textarea');
                        const formulaInputValue = formulaInput.val() ? formulaInput.val() : formulaInput.text();
                        appn.ui.formulabuilder.currentFormula = formulaInputValue;
                        appn.ui.formulabuilder.currentMode = icon.data('type');
                        appn.ui.formulabuilder.formulaUpdated = function (formula) {
                            formulaInput.val(formula);
                        };
                        appn.ui.formulabuilder.showDialog();
                    });
                    $(document).on('input', '.responseMappingVal', function () {
                        const currentVal = $(this).val();
                        if (!currentVal)
                            return;
                        const keyField = $(this).closest('tr').find('.responseMappingKey');
                        const currentValLessLast = currentVal.substring(0, currentVal.length - 1);
                        if (keyField.val() && currentValLessLast !== keyField.val())
                            return;
                        if (!currentVal.containsIgnoreCase('.')) {
                            keyField.val(currentVal);
                            return;
                        }
                        keyField.val(currentVal.replace(/\./g, '_'));
                    });
                    $(document).on('click', '.btnRestAddStep', function (event) {
                        event.preventDefault();
                        $('.restPreStepContainer,.btnRestRemoveStep,.appn-dropdown-group,.btnRestModifyHeadersPreStep').showElement();
                        $('.btnRestAddStep').hideElement();
                        showHideBodyPreStep($('#RESTConnector_PreStep_Format').val());
                        showHideFormDataPreStep($('#RESTConnector_PreStep_Format').val());
                    });
                    $(document).on('click', '.btnRestRemoveStep', function (event) {
                        event.preventDefault();
                        $('.btnRestAddStep').showElement();
                        $('.restPreStepContainer,.btnRestRemoveStep,.appn-dropdown-group,.btnRestModifyHeadersPreStep,.btnRestModifyBodyPreStep').hideElement();
                        $('#RESTConnector_PreStep_Url').val(appn.emptyString);
                        $('#RESTConnector_PreStep_Format').val('Json');
                        $('#RESTConnector_PreStep_Body').val(appn.emptyString);
                        clearRestFormDataItems('PreStep');
                        clearRestHeaderItems('PreStep');
                    });
                    $(document).on('change', '#RESTConnector_HttpAction', function (event) {
                        showHideBody($('#RESTConnector_FormatType').val());
                        showHideFormData($('#RESTConnector_FormatType').val());
                    });
                    $(document).on('change', '#RESTConnector_PreStep_Verb', function (event) {
                        showHideBodyPreStep($('#RESTConnector_PreStep_Format').val());
                        showHideFormDataPreStep($('#RESTConnector_PreStep_Format').val());
                    });
                    $('select[id$="_ConnectionId"]').on('change', function () {
                        showHideSiteNameOrCamlFilterOnSelect($(this));
                    });
                    $('input.graph-sitename-input').on('change', function () {
                        const siteName = $(this);
                        const connector = siteName.closest('.connector');
                        const inputDriveName = connector.find('div.input-drive-name');
                        inputDriveName.toggleClass('d-none', !siteName || !siteName.val());
                    });
                    $('select[id$="ConnectionId"]').on('change', function () {
                        const connector = $(this).closest('.connector');
                        const connectionType = $(this).find(':selected').data('appnConnectionType');
                        if (connectionType.toLowerCase() === 'google') {
                            const useRestricted = $(this).find(':selected').data('googleUseRestricted');
                            if (useRestricted.toLowerCase() === 'true') {
                                connector.find('.restricted-scopes').removeClass('d-none');
                                connector.find('.unrestricted-scopes').addClass('d-none');
                            }
                            else {
                                connector.find('.restricted-scopes').addClass('d-none');
                                connector.find('.unrestricted-scopes').removeClass('d-none');
                            }
                        }
                        else {
                            const siteName = connector.find('input.graph-sitename-input');
                            const inputDriveName = connector.find('div.input-drive-name');
                            inputDriveName.toggleClass('d-none', !siteName || !siteName.val());
                        }
                    });
                    $(document).on('change', '#XeroConnector_Api', function () {
                        const connector = $('div[class*="box-connector-Xero"]');
                        xeroUpdateEndpointSelect(connector);
                        const apiValue = $(this).val();
                        const endpoint = connector.find('select[id$="_Endpoint"]');
                        const endpointValue = endpoint.val();
                        xeroTogglePropertiesOnApiEndpointSelect(connector, apiValue, endpointValue);
                    });
                    $(document).on('change', '#XeroConnector_Endpoint', function () {
                        const connector = $(this).closest('.connector');
                        const apiValue = connector.find('select[id$="_Api"]').val();
                        const endpointValue = $(this).val();
                        xeroTogglePropertiesOnApiEndpointSelect(connector, apiValue, endpointValue);
                    });
                    $(document).on('change', '#AcumaticaConnector_Endpoint', function () {
                        const connector = $(this).closest('.box-connector-Acumatica');
                        const endpointValue = $(this).val();
                        acumaticaTogglePropertiesOnEndpointSelect(connector, endpointValue);
                    });
                    $('.btn-google-picker').on('click', function (e) {
                        e.preventDefault();
                        const connector = $(this).closest('.connector');
                        const connectionId = connector.find('[id$="ConnectionId"]').val();
                        const pickerId = connector.find('.google-picker-id');
                        const pickerName = connector.find('.google-picker-name');
                        const spreadsheet = connector.find('.google-spreadsheet');
                        $.ajax({
                            headers: appn.verifyHeader,
                            url: _initArgs.googleAccessTokenUrl,
                            type: 'POST',
                            data: { connId: connectionId },
                            success: function (data, status, xhttp) {
                                const response = JSON.parse(data);
                                var view = new google.picker.DocsView()
                                    .setIncludeFolders(true);
                                if (spreadsheet.length === 0)
                                    view.setMimeTypes('text/csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
                                else
                                    view.setMimeTypes('application/vnd.google-apps.spreadsheet');
                                this.picker = new google.picker.PickerBuilder()
                                    .setAppId(response.ClientId)
                                    .setOAuthToken(response.accessToken)
                                    .addView(view)
                                    .setCallback(function (data) {
                                    if (data[google.picker.Response.ACTION] == google.picker.Action.PICKED) {
                                        var file = data[google.picker.Response.DOCUMENTS][0];
                                        var id = file[google.picker.Document.ID];
                                        pickerId.val(id);
                                        pickerName.val(file.name);
                                    }
                                })
                                    .build()
                                    .setVisible(true);
                            },
                            error: function (data, message, message2) {
                                appn.toast.notify(appn.toast.Type.error, T('Could not fetch access token.'));
                            }
                        });
                    });
                    $('#featurelayerheadings').on('change', function (event) {
                        event.preventDefault();
                        if ($(this).val() === '0')
                            return;
                        const columnName = $(this).val();
                        const type = appn.elementBuilder.RowType[$(this).find('option:checked').attr('row-type')];
                        const idx = $('#FeatureLayerMapping tbody').children().length;
                        if (idx == 0)
                            $('#FeatureLayerMapping').removeClass("d-none");
                        const newRow = `<tr>` +
                            `<td class="dataCol name"> <input class="mappingKey" type="hidden" name="ArcGisConnector.FeatureLayerMappings[${idx}].DisplayName" value="${$(this).val()}"/><label class="col-form-label col-form-label-sm mappingKey" name="ArcGisConnector.FeatureLayerMappings[${idx}].DisplayName">${$(this).val()}</label></td>` +
                            `<td class="dataCol value"><input class="form-control form-control-sm mappingVal" type="text" name="ArcGisConnector.FeatureLayerMappings[${idx}].ColumnName" value="${$(this).val()}"></td>` +
                            `<td class="text-right activity-row-options">` +
                            `<div class="btn-group" role="group">` +
                            `${appn.elementBuilder.buildBtnMoveRow(true)}` +
                            `${appn.elementBuilder.buildBtnMoveRow(false)}` +
                            `${appn.elementBuilder.buildBtnRemoveRow('delete_button')}` +
                            `</div>` +
                            `</td>`;
                        $(`#FeatureLayerMapping tbody`).append(newRow);
                        $(`#featurelayerheadings option[value="${$(this).val()}"]`).prop('disabled', true);
                        $(`#featurelayerheadings`).val('0');
                        appn.select.init();
                    });
                    $(document).on('click', '.delete_button', function (e) {
                        e.preventDefault();
                        const tableId = $(this).closest('table').attr('id');
                        if (tableId === 'FeatureLayerMapping') {
                            const row = $(this).parents('tr');
                            $(`#featurelayerheadings option[value="${row.find('.mappingKey').text()}"]`).prop('disabled', false);
                            row.remove();
                            renameFeatureLayerMapping();
                        }
                    });
                    $(document).on('click', '.down_button', function () {
                        const tableId = $(this).closest('table').attr('id');
                        if (tableId === 'FeatureLayerMapping') {
                            const rowToMove = $(this).parents('#FeatureLayerMapping tbody tr:first');
                            const next = rowToMove.next('#FeatureLayerMapping tbody tr');
                            if (next.length === 1) {
                                next.after(rowToMove);
                                renameFeatureLayerMapping();
                            }
                        }
                    });
                    $(document).on('click', '.up_button', function () {
                        const tableId = $(this).closest('table').attr('id');
                        if (tableId === 'FeatureLayerMapping') {
                            const rowToMove = $(this).parents('#FeatureLayerMapping tbody tr:first');
                            const prev = rowToMove.prev('#FeatureLayerMapping tbody tr');
                            if (prev.length === 1) {
                                prev.before(rowToMove);
                                renameFeatureLayerMapping();
                            }
                        }
                    });
                }
                function renameFeatureLayerMapping() {
                    let idx = 0;
                    $('#FeatureLayerMapping tbody tr').each(function (index, row) {
                        $(this).find('.mappingKey').attr('name', `ArcGisConnector.FeatureLayerMappings[${idx}].DisplayName`);
                        $(this).find('.mappingVal').attr('name', `ArcGisConnector.FeatureLayerMappings[${idx}].ColumnName`);
                        idx++;
                    });
                }
                function addTrashMessage() {
                    const submitButton = $('nav .navbar-nav-right button[value="Trash"].btn-danger');
                    submitButton.attr('data-trashdetail', appn.emptyString);
                    const p = appn.elementBuilder.createElement('p', undefined, undefined, undefined, `<b>${$('#DataSource_Name').val()}</b> will be moved to Trash and will no longer be available for use.`);
                    submitButton.attr('data-trashdetail', JSON.stringify(p.outerHTML));
                }
                function showHideBody(dataType, isBtnClick) {
                    const httpVerb = $('#RESTConnector_HttpAction').val();
                    if (httpVerb === 'Get') {
                        $('.btnRestModifyBody').hideElement();
                        $('.form-control-dsrest-body').hideElement();
                        return;
                    }
                    if (dataType === 'Xml' || dataType === 'Json') {
                        if ($('#RESTConnector_Body').val() || isBtnClick) {
                            $('.form-control-dsrest-body').showElement();
                            $('.btnRestModifyBody').hideElement();
                            return;
                        }
                        $('.form-control-dsrest-body').hideElement();
                        $('.btnRestModifyBody').showElement();
                        return;
                    }
                    $('.form-control-dsrest-body').hideElement();
                    $('.btnRestModifyBody').hideElement();
                }
                function showHideFormData(dataType) {
                    const httpVerb = $('#RESTConnector_HttpAction').val();
                    if (httpVerb === 'Get') {
                        $('#RESTConnector_FormatType option[value="UrlEncoded"]').attr('disabled', 'disabled');
                        $('.form-control-dsrest-formData').hideElement();
                        if ($('#RESTConnector_FormatType').val() === 'UrlEncoded')
                            $('#RESTConnector_FormatType').val('Json');
                        return;
                    }
                    $('#RESTConnector_FormatType option[value="UrlEncoded"]').removeAttr('disabled');
                    initInlineSelects();
                    if (dataType === 'UrlEncoded') {
                        $('.form-control-dsrest-formData').showElement();
                        return;
                    }
                    $('.form-control-dsrest-formData').hideElement();
                }
                function showHideBodyPreStep(dataType, isBtnClick) {
                    const httpVerb = $('#RESTConnector_PreStep_Verb').val();
                    if (httpVerb === 'Get') {
                        $('.btnRestModifyBodyPreStep').hideElement();
                        $('.form-control-dsrest-body-prestep').hideElement();
                        return;
                    }
                    if (dataType === 'Xml' || dataType === 'Json') {
                        if ($('#RESTConnector_PreStep_Body').val() || isBtnClick) {
                            $('.form-control-dsrest-body-prestep').showElement();
                            $('.btnRestModifyBodyPreStep').hideElement();
                            return;
                        }
                        $('.form-control-dsrest-body-prestep').hideElement();
                        $('.btnRestModifyBodyPreStep').showElement();
                        return;
                    }
                    $('.form-control-dsrest-body-prestep').hideElement();
                    $('.btnRestModifyBodyPreStep').hideElement();
                }
                function showHideFormDataPreStep(dataType) {
                    const httpVerb = $('#RESTConnector_PreStep_Verb').val();
                    if (httpVerb === 'Get') {
                        $('#RESTConnector_PreStep_Format option[value="UrlEncoded"]').attr('disabled', 'disabled');
                        $('.form-control-dsrest-formData-prestep').hideElement();
                        if ($('#RESTConnector_PreStep_Format').val() === 'UrlEncoded')
                            $('#RESTConnector_PreStep_Format').val('Json');
                        return;
                    }
                    $('#RESTConnector_PreStep_Format option[value="UrlEncoded"]').removeAttr('disabled');
                    initInlineSelects();
                    if (dataType === 'UrlEncoded') {
                        $('.form-control-dsrest-formData-prestep').showElement();
                        return;
                    }
                    $('.form-control-dsrest-formData-prestep').hideElement();
                }
                function deleteRestResponseMapping(_this) {
                    _this.parents('tr').remove();
                    renameRestResponseMappingRows();
                    if ($('#restResponseMapping tbody').children().length === 0) {
                        $('#restResponseMapping').hideElement();
                        $('.addRestResponseMappingItem').css('top', '-20px');
                    }
                }
                function addRestResponseMappingItem() {
                    if ($('#restResponseMapping tbody').children().length === 0) {
                        $('#restResponseMapping').showElement();
                        $('.addRestResponseMappingItem').css('top', '0px');
                    }
                    const idx = $('#restResponseMapping tbody').children().length;
                    const newRow = `<tr>` +
                        `<td class="dataCol"><input class="form-control form-control-sm responseMappingVal" type="text" name="RESTConnector.ResponseMapping[${idx}].Val" id="RESTConnector_ResponseMapping_${idx}__Val"></td>` +
                        `<td class="dataCol"><input class="form-control form-control-sm responseMappingKey" type="text" name="RESTConnector.ResponseMapping[${idx}].Key" id="RESTConnector_ResponseMapping_${idx}__Key"></td>` +
                        `<td class="closeCell">${appn.elementBuilder.buildBtnRemoveRow('deleteRestResponseMappingItem', 'data-tablename="responseMapping"')}</td>` +
                        `</tr>`;
                    $('#restResponseMapping tbody').append(newRow);
                }
                function renameRestResponseMappingRows() {
                    $('#restResponseMapping tbody tr').each(function (index, row) {
                        $(this).find('.responseMappingKey')
                            .attr('name', `RESTConnector.ResponseMapping[${index}].Key`)
                            .attr('id', `RESTConnector_ResponseMapping_${index}__Key`);
                        $(this).find('.responseMappingVal')
                            .attr('name', `RESTConnector.ResponseMapping[${index}].Val`)
                            .attr('id', `RESTConnector_ResponseMapping_${index}__Val`);
                    });
                }
                function deleteRestHeaderItem(_this, suffix) {
                    _this.closest('tr').remove();
                    renameRestHeaderRows(suffix);
                    if ($(`#restHeaders${suffix} tbody`).children().length === 0) {
                        $(`#restHeaders${suffix}`).hideElement();
                        $(`.addRestHeaderItem${suffix}`).css('top', '-20px');
                    }
                }
                function clearRestHeaderItems(suffix) {
                    $(`#restHeaders${suffix} tbody tr`).each(function (index, item) {
                        deleteRestHeaderItem($(item), suffix);
                    });
                    $('.form-control-dsrest-headers-prestep').hideElement();
                }
                function addRestHeaderItem(suffix) {
                    if ($(`#restHeaders${suffix} tbody`).children().length === 0) {
                        $(`#restHeaders${suffix}`).showElement();
                        $(`.addRestHeaderItem${suffix}`).css('top', '0px');
                    }
                    const idx = $(`#restHeaders${suffix} tbody`).children().length;
                    const newRow = `<tr>` +
                        `<td class="dataCol"><input class="form-control form-control-sm headerKey${suffix}" type="text" name="RESTConnector${(suffix ? '.PreStep' : appn.emptyString)}.Headers[${idx}].Key" id="RESTConnector${(suffix ? '_PreStep' : appn.emptyString)}_Headers_${idx}__Key"></td>` +
                        `<td class="dataCol"><div class="input-group input-group-sm"><textarea class="form-control form-control-sm headerVal${suffix}" type="text" name="RESTConnector${(suffix ? '.PreStep' : appn.emptyString)}.Headers[${idx}].Val" id="RESTConnector${(suffix ? '_PreStep' : appn.emptyString)}_Headers_${idx}__Val"></textarea><span class="input-group-append">${appn.elementBuilder.buildIconButton('template')}</span></div></td>` +
                        `<td class="closeCell">${appn.elementBuilder.buildBtnRemoveRow(`deleteRestHeaderItem${suffix}`, `data-tablename="restHeaders${suffix}"`)}</td>` +
                        `</tr>`;
                    $(`#restHeaders${suffix} tbody`).append(newRow);
                }
                function renameRestHeaderRows(suffix) {
                    $(`#restHeaders${suffix} tbody tr`).each(function (index, row) {
                        $(this).find(`.headerKey${suffix}`)
                            .attr('name', `RESTConnector${(suffix ? '.PreStep' : appn.emptyString)}.Headers[${index}].Key`)
                            .attr('id', `RESTConnector${(suffix ? '_PreStep' : appn.emptyString)}_Headers_${index}__Key`);
                        $(this).find(`.headerVal${suffix}`)
                            .attr('name', `RESTConnector${(suffix ? '.PreStep' : appn.emptyString)}.Headers[${index}].Val`)
                            .attr('id', `RESTConnector${(suffix ? '_PreStep' : appn.emptyString)}_Headers_${index}__Val`);
                    });
                }
                function deleteRestFormDataItem(_this, suffix) {
                    _this.closest('tr').remove();
                    renameRestFormDataRows(suffix);
                    if ($(`#restFormData${suffix} tbody`).children().length === 0) {
                        $(`#restFormData${suffix}`).hideElement();
                        $(`.addRestFormDataItem${suffix}`).css('top', '-20px');
                    }
                }
                function clearRestFormDataItems(suffix) {
                    $(`#restFormData${suffix} tbody tr`).each(function (index, item) {
                        deleteRestFormDataItem($(item), suffix);
                    });
                    $('.form-control-dsrest-formData-prestep').hideElement();
                }
                function addRestFormDataItem(suffix) {
                    if ($(`#restFormData${suffix} tbody`).children().length === 0) {
                        $(`#restFormData${suffix}`).showElement();
                        $(`.addRestFormDataItem${suffix}`).css('top', '0px');
                    }
                    const idx = $(`#restFormData${suffix} tbody`).children().length;
                    const newRow = `<tr>` +
                        `<td class="dataCol"><input class="form-control form-control-sm formDataKey${suffix}" type="text" name="RESTConnector${(suffix ? '.PreStep' : appn.emptyString)}.FormData[${idx}].Key" id="RESTConnector${(suffix ? '_PreStep' : appn.emptyString)}_FormData_${idx}__Key"></td>` +
                        `<td class="dataCol"><div class="input-group input-group-sm"><textarea class="form-control form-control-sm formDataVal${suffix}" type="text" name="RESTConnector${(suffix ? '.PreStep' : appn.emptyString)}.FormData[${idx}].Val" id="RESTConnector${(suffix ? '_PreStep' : appn.emptyString)}_FormData_${idx}__Val"></textarea><span class="input-group-append">${appn.elementBuilder.buildIconButton('template')}</span></div></td>` +
                        `<td class="closeCell">${appn.elementBuilder.buildBtnRemoveRow(`deleteRestFormDataItem${suffix}`, `data-tablename="restFormData${suffix}"`)}</td>` +
                        `</tr>`;
                    $(`#restFormData${suffix} tbody`).append(newRow);
                }
                function renameRestFormDataRows(suffix) {
                    $(`#restFormData${suffix} tbody tr`).each(function (index, row) {
                        $(this).find(`.formDataKey${suffix}`)
                            .attr('name', `RESTConnector${(suffix ? '.PreStep' : appn.emptyString)}.FormData[${index}].Key`)
                            .attr('id', `RESTConnector${(suffix ? '_PreStep' : appn.emptyString)}_FormData_${index}__Key`);
                        $(this).find(`.formDataVal${suffix}`)
                            .attr('name', `RESTConnector${(suffix ? '.PreStep' : appn.emptyString)}.FormData[${index}].Val`)
                            .attr('id', `RESTConnector${(suffix ? '_PreStep' : appn.emptyString)}_FormData_${index}__Val`);
                    });
                }
                function toggleInputHideOrShowForGroup(connector, groupName) {
                    const siteName = connector.find('#OneDriveBusinessConnector_SiteName').closest('div.row');
                    const camlFilterQuery = $('.caml-filter-query');
                    const graphFilter = $('.graph-filter');
                    if (groupName !== 'MicrosoftGraph' && appn.utils.hasValue(siteName)) {
                        siteName.find('input').val(appn.emptyString);
                        siteName.hideElement();
                    }
                    else if (groupName === 'MicrosoftGraph' && appn.utils.hasValue(siteName))
                        siteName.showElement();
                    if (groupName !== 'MicrosoftGraph' && appn.utils.hasValue(camlFilterQuery) && appn.utils.hasValue(graphFilter)) {
                        camlFilterQuery.showElement();
                        graphFilter.hideElement();
                    }
                    else if (groupName === 'MicrosoftGraph' && appn.utils.hasValue(camlFilterQuery) && appn.utils.hasValue(graphFilter)) {
                        graphFilter.showElement();
                        camlFilterQuery.hideElement();
                    }
                }
                function showHideSiteNameOrCamlFilter(connector) {
                    var _a;
                    if (!appn.utils.hasValue(connector) || connector === undefined)
                        connector = $('div[class*="box-connector-"]');
                    if (!appn.utils.hasValue(connector))
                        return;
                    const classes = connector.attr('class').split(' ');
                    const groupName = (_a = classes.filter((o) => o.contains('group-'))[0]) === null || _a === void 0 ? void 0 : _a.replace('group-', appn.emptyString);
                    if (!appn.utils.hasValue(groupName) || groupName === 'None')
                        return;
                    if (groupName !== 'OneDriveBusiness' && groupName !== 'SharePoint' && groupName !== 'MicrosoftGraph')
                        return;
                    toggleInputHideOrShowForGroup(connector, groupName);
                }
                function showHideSiteNameOrCamlFilterOnSelect(select) {
                    const connector = $(select).closest('.connector');
                    const classes = connector.attr('class').split(' ').filter((o) => {
                        return o.indexOf('box-connector-') > -1;
                    });
                    if (classes.length < 1)
                        return;
                    const connectorName = classes[0].replace('box-connector-', appn.emptyString);
                    if (connectorName !== 'OneDriveBusiness' && connectorName !== 'SharePoint')
                        return;
                    const selected = $(select).val();
                    const groupName = $(select).find(`option[value="${selected}"]`).closest('optgroup').attr('label');
                    toggleInputHideOrShowForGroup(connector, groupName.replace(' ', ''));
                }
                const xeroEndpointOptionDisplay = {};
                function xeroUpdateEndpointSelect(connector) {
                    var _a;
                    const endpoint = connector.find('select[id$="XeroConnector_Endpoint"]');
                    const apiSelect = connector.find('select[id$="XeroConnector_Api"]');
                    if (!xeroEndpointOptionDisplay[appn.XeroEndpoint.Accounts]) {
                        endpoint.find('option').each((_, o) => {
                            const option = $(o);
                            xeroEndpointOptionDisplay[option.val()] = option.text();
                        });
                    }
                    const group = {
                        Disabled: false,
                        Name: appn.emptyString
                    };
                    const selectOptionTemplate = [];
                    for (const key in appn.XeroEndpoint) {
                        if (Object.prototype.hasOwnProperty.call(appn.XeroEndpoint, key)) {
                            selectOptionTemplate.push({
                                disabled: false,
                                group: group,
                                selected: key === endpoint.val(),
                                text: (_a = xeroEndpointOptionDisplay[key]) !== null && _a !== void 0 ? _a : key,
                                value: key
                            });
                        }
                    }
                    const newSelect = $(appn.elementBuilder.buildSelectGeneric(selectOptionTemplate, endpoint.attr('id'), endpoint.attr('class'), T('Select Endpoint'), endpoint.attr('name')));
                    const options = newSelect.find('option');
                    const accountingOptions = ['Accounts', 'Contacts', 'Invoices', 'Items', 'TrackingCategories'];
                    const payrollOptions = ['Timesheet', 'Employees'];
                    switch (apiSelect.val()) {
                        case appn.XeroApi.None: {
                            newSelect.attr('disabled', 'disabled');
                            options.each((_, o) => {
                                const option = $(o);
                                option.removeAttr('selected');
                                if (option.val() === '')
                                    option.attr('selected', 'selected');
                            });
                            break;
                        }
                        case appn.XeroApi.Accounting: {
                            options.each((_, o) => {
                                const option = $(o);
                                if (!accountingOptions.includes(option.val()))
                                    option.remove();
                            });
                            break;
                        }
                        case appn.XeroApi.PayrollAU:
                        case appn.XeroApi.PayrollUK:
                        case appn.XeroApi.PayrollNZ: {
                            options.each((i, o) => {
                                const option = $(o);
                                if (!payrollOptions.includes(option.val()))
                                    option.remove();
                            });
                            break;
                        }
                    }
                    endpoint.replaceWith(newSelect);
                    appn.select.init({ selector: `.box-connector-Xero #${newSelect.attr('id')}` });
                }
                function xeroTogglePropertiesOnApiEndpointSelect(connector, api, endpoint) {
                    connector.find('.accounts').hideElement();
                    connector.find('.contacts').hideElement();
                    connector.find('.auEmployees').hideElement();
                    connector.find('.ukNzEmployees').hideElement();
                    connector.find('.invoices').hideElement();
                    connector.find('.items').hideElement();
                    connector.find('.trackingCats').hideElement();
                    connector.find('.auTimesheets').hideElement();
                    connector.find('.ukNzTimesheets').hideElement();
                    switch (endpoint) {
                        case appn.XeroEndpoint.Accounts:
                            connector.find('.accounts').showElement();
                            break;
                        case appn.XeroEndpoint.Contacts:
                            connector.find('.contacts').showElement();
                            break;
                        case appn.XeroEndpoint.Employees:
                            switch (api) {
                                case appn.XeroApi.PayrollAU:
                                    connector.find('.auEmployees').showElement();
                                    break;
                                case appn.XeroApi.PayrollUK:
                                case appn.XeroApi.PayrollNZ:
                                    connector.find('.ukNzEmployees').showElement();
                                    break;
                            }
                            break;
                        case appn.XeroEndpoint.Invoices:
                            connector.find('.invoices').showElement();
                            break;
                        case appn.XeroEndpoint.Items:
                            connector.find('.items').showElement();
                            break;
                        case appn.XeroEndpoint.TrackingCategories:
                            connector.find('.trackingCats').showElement();
                            break;
                        case appn.XeroEndpoint.Timesheet:
                            switch (api) {
                                case appn.XeroApi.PayrollAU:
                                    connector.find('.auTimesheets').showElement();
                                    break;
                                case appn.XeroApi.PayrollUK:
                                case appn.XeroApi.PayrollNZ:
                                    connector.find('.ukNzTimesheets').showElement();
                                    break;
                            }
                            break;
                    }
                }
                function acumaticaTogglePropertiesOnEndpointSelect(connector, endpoint) {
                    if (endpoint === appn.AcumaticaEndpoint.GenericInquiry) {
                        connector.find('.acumatica-rest-fields').hideElement();
                        connector.find('.acumatica-gi-fields').showElement();
                        return;
                    }
                    connector.find('.acumatica-gi-fields').hideElement();
                    connector.find('.acumatica-rest-fields').showElement();
                }
            })(settings = dataSources.settings || (dataSources.settings = {}));
        })(dataSources = views.dataSources || (views.dataSources = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
